import { Estimate } from 'components/SummitFlow/Estimate';
import { TrackedPhoneNumber } from '@/components/TrackedPhoneNumber';

import Checkmark from 'svgs/summit/checkmark.svg';

import styles from './index.module.scss';

import { FC } from 'react';

export const Thanks: FC = () => {
  return (
    <div className="summit-wrapper">
      <div className={styles['thanks-hero-container']}>
        <div className={`container ${styles['main']}`}>
          <div className={styles['icon-container']}>
            <Checkmark />
          </div>
          <h1>You&apos;re all set!</h1>
          <h2>You should get a text within seconds and hear from local professionals shortly.</h2>
          <p>
            If you don&apos;t receive a message with a local pro&apos;s information, you can call us at <TrackedPhoneNumber className={styles['phone-number']} /> and we can connect you.
          </p>
          <Estimate />
        </div>
      </div>
    </div>
  );
};
